var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.982422 17.7669C1.10142 17.3149 1.22442 16.867 1.33842 16.411C1.59242 15.404 1.83842 14.394 2.09542 13.388C2.12469 13.2799 2.18115 13.1811 2.25942 13.101C5.56809 9.78562 8.87875 6.47262 12.1914 3.16195C12.2204 3.13295 12.2524 3.10695 12.2724 3.08795L16.2234 7.03895C16.1658 7.07356 16.1113 7.11303 16.0604 7.15695C12.7978 10.417 9.53676 13.6783 6.27742 16.941C6.13652 17.0853 5.95703 17.1859 5.76042 17.231C4.37042 17.572 2.98242 17.9189 1.59542 18.2669C1.56853 18.2765 1.54272 18.289 1.51842 18.304H0.982422V17.768",
    fill: "#161615"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4668 1.94594C13.9378 1.45994 14.4018 0.927937 14.9228 0.458937C15.2934 0.152133 15.7629 -0.0096821 16.2438 0.00356058C16.7248 0.0168033 17.1846 0.204203 17.5378 0.530937C17.9598 0.924937 18.3678 1.3336 18.7618 1.75694C19.1045 2.11707 19.2962 2.59474 19.2977 3.09184C19.2992 3.58895 19.1103 4.06776 18.7698 4.42994C18.3118 4.92094 17.8148 5.37694 17.3508 5.82994L13.4678 1.94294",
    fill: "#161615"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.570cf8516f5a80d85a40ea791d3f7d75.svg";
export { ForwardRef as ReactComponent };